import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import CloseAccountActions from 'actions/CloseAccountActions';
import AccountDeactivatedModalEN from 'components/GlobalModals/AccountDeactivatedModal/locales/AccountDeactivatedModal_en_US';
import AccountDeactivatedModalFR from 'components/GlobalModals/AccountDeactivatedModal/locales/AccountDeactivatedModal_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;
const { closeDeactivatedAccountModal } = CloseAccountActions;
const getText = getLocalisedDataFromResource(AccountDeactivatedModalEN, AccountDeactivatedModalFR);

const fields = createSelector(
    createStructuredSelector({
        title: getTextFromResource(getText, 'title'),
        confirmText: getTextFromResource(getText, 'confirmText')
    }),
    localization => ({
        localization
    })
);

const functions = { closeDeactivatedAccountModal };

const withAccountDeactivatedModalProps = wrapHOC(connect(fields, functions));

export {
    withAccountDeactivatedModalProps, fields, functions
};
